import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Calendar, Clock, User, Eye } from 'lucide-react';
import axios from 'axios';
import SEO from '../components/SEO';
import Breadcrumb from '../components/Breadcrumb';
import './Blog.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api/blog`;

const Blog = () => {
  const navigate = useNavigate();
  const [posts, setPosts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPosts();
    fetchCategories();
  }, [selectedCategory]);

  const fetchPosts = async () => {
    try {
      const url = selectedCategory 
        ? `${API}/posts?category=${selectedCategory}` 
        : `${API}/posts`;
      const response = await axios.get(url);
      setPosts(response.data);
    } catch (error) {
      console.error('Error fetching posts:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${API}/categories`);
      setCategories(response.data);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('fr-FR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <>
      <SEO 
        title="Blog CYGA EVENEMENT - Actualités & Conseils Pyrotechnie"
        description="Découvrez les actualités CYGA EVENEMENT, nos conseils pour organiser vos spectacles pyrotechniques, et les tendances en matière de feux d'artifice."
        keywords="blog pyrotechnie, actualités feux d'artifice, conseils spectacle, CYGA blog"
        url="https://www.cyga-evenement.fr/blog"
      />
      
      <div className="blog-page">
        <Breadcrumb items={[{ label: 'Blog' }]} />

        <div className="blog-header">
          <button onClick={() => navigate('/')} className="back-button">
            <ArrowLeft /> Retour
          </button>
          <h1>Blog CYGA EVENEMENT</h1>
          <p>Actualités, conseils et inspirations pyrotechniques</p>
        </div>

        {/* Filtres par catégorie */}
        <div className="blog-filters">
          <button 
            onClick={() => setSelectedCategory(null)}
            className={`filter-btn ${!selectedCategory ? 'active' : ''}`}
          >
            Tous
          </button>
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setSelectedCategory(cat)}
              className={`filter-btn ${selectedCategory === cat ? 'active' : ''}`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Liste des articles */}
        <div className="blog-grid">
          {loading ? (
            <p>Chargement...</p>
          ) : posts.length === 0 ? (
            <div className="no-posts">
              <p>Aucun article disponible pour le moment.</p>
              <p>Revenez bientôt pour découvrir nos actualités !</p>
            </div>
          ) : (
            posts.map((post) => (
              <article key={post.id} className="blog-card" onClick={() => navigate(`/blog/${post.slug}`)}>
                {post.image_url && (
                  <div className="blog-card-image">
                    <img 
                      src={post.image_url} 
                      alt={post.title}
                      loading="lazy"
                    />
                  </div>
                )}
                <div className="blog-card-content">
                  <div className="blog-card-meta">
                    <span className="blog-category">{post.category}</span>
                    <span className="blog-date">
                      <Calendar size={14} />
                      {formatDate(post.created_at)}
                    </span>
                  </div>
                  <h2>{post.title}</h2>
                  <p>{post.excerpt}</p>
                  <div className="blog-card-footer">
                    <span className="blog-author">
                      <User size={14} />
                      {post.author}
                    </span>
                    <span className="blog-views">
                      <Eye size={14} />
                      {post.views} vues
                    </span>
                  </div>
                </div>
              </article>
            ))
          )}
        </div>
      </div>
    </>
  );
};

export default Blog;
